<template>
    <v-container id="marketing-report" fluid tag="section">
        <filter-form
            :users="users"
            :filterForm="filterForm"
        />

        <v-select
            v-model="filterForm.typeId"
            :items="types"
            item-value="id"
            item-text="name"
            :menu-props="{ offsetY: true, offsetOverflow: true }"
            label="Chọn"
            style="width: 180px"
            class="select-type-school"
            background-color="#e91e63"
            color="#fff"
            solo
        />
        <v-card class="mt-4">
            <v-tabs
                v-model="tab"
                grow
                @change="onChangeTab()"
            >
            <v-tabs-slider></v-tabs-slider>

                <v-tab
                    v-for="(item, key) in tabs"
                    :key="key"
                >
                    {{item.name}}
                </v-tab>
                <v-tab-item
                    v-for="(item, key) in tabs"
                    :key="key"
                >
                    <content-table 
                        :contentReports="contentReports" 
                        :total="total" 
                    />
                </v-tab-item>
            </v-tabs>
        </v-card>
    </v-container>
</template>

<script>
import FilterForm from './components/FilterForm'
import ContentTable from './components/ContentTable'
import moment from 'moment'
import RepositoryFactory from "@/repositories/RepositoryFactory"
import { SCHOOL_LEVEL_LIST } from "../../../helpers/constants";

const ReportRepository = RepositoryFactory.get('report')
const OrganizationMachineRepository = RepositoryFactory.get('organization_machine')
const SchoolLevelRepository = RepositoryFactory.get('school_level')

export default {
    components: {
        FilterForm,
        ContentTable
    },
    data() {
        return {
            users: [],
            tabs: [],
            types: [],
            tab: 0,
            filterForm: {
                createdAt: [moment().startOf('week').format('YYYY-MM-DD'), moment().endOf('week').format('YYYY-MM-DD')],
                userIds: [],
                codeSource: '',
                schoolLevelId: undefined,
                typeId: undefined,
            },
            contentReports: [],
            total: {}
        }
    },
    created() {
        this.getUsers()
        this.getListModuleMKT()
        if(this.types.length > 0){
            this.getContentReport()
        }

        Bus.$on('marketing-report-by-content-list-filter', filterForm => {
            this.filterForm = filterForm
            this.getContentReport()
        })
    },
    beforeDestroy() {
        Bus.$off('marketing-report-by-content-list-filter')
    },
    watch: {
        'filterForm.typeId': function(newValue){
            if(newValue && this.types.length > 0){
                this.tabs = this.getTabs(newValue)
            }else  this.tabs = []

            this.tab = this.tabs.length > 0 ? 0 : null
            this.onChangeTab()
        }
    },
    methods: {
        async getUsers() {
            const res = await OrganizationMachineRepository.listUser({ 
                status: 'active'
            })

            if (res.success) {
                let listUsers = _.get(res, 'data', [])
                const groupUsers = [];
                listUsers.forEach(ministry => {
                    const { users = [] } = ministry;
                    if (users.length) {
                        groupUsers.push({
                            header: ministry.name,
                            name: _.get(ministry, 'name'),
                            ministryId: ministry.id,
                        });
                        users.forEach(user => {
                            groupUsers.push({
                                fullName: _.get(user, 'fullName'),
                                group: _.get(ministry, 'name'),
                                id: user.id,
                                avatar: _.get(user, 'avatar.filePath'),
                                ministryId: ministry.id,
                            });
                        });
                    }
                });
                this.users = groupUsers;
            } else {
                this.$swal({
                    title: 'Lỗi!',
                    text: _.get(res, 'message', '')
                })
            }
        },
        getTabs(typeId){
            const result = this.types.find((school) => school.id === typeId)
            return result?.schoolLevel || []
        },
        async getContentReport() {
            const loader = this.$loading.show();
            const params = {
                ...this.filterForm,
                typeId: this.filterForm.typeId === 1000 ? undefined : this.filterForm.typeId
            }

            const res = await ReportRepository.marketingReportByContent(params)
            loader.hide();

            if(res.success) {
                let contentReports = _.get(res, 'data.contentData', [])
                this.contentReports = contentReports.map(i => {
                    return {
                        ...i,
                        rowspan: i.codeSources ? i.codeSources.length : 1
                    }
                })
                this.total = _.get(res, 'data.total', {})
            } else {
                this.contentReports = []
                this.total = {}
                this.$swal({
                    type: 'error',
                    title: 'Lỗi !',
                    text: _.get(res, 'message', '')
                });
            }
        },
        async getListModuleMKT() {
            let responseMKT = {};
            if (this.checkAuthorization('marketing-report-by-content_view_all') || this.checkAuthorization('marketer-report_view_all')) {
              if (this.$store.state.listSchoolLevelDrawer) {
                responseMKT['data'] = _.cloneDeep(this.$store.state.listSchoolLevelDrawer)
              } else {
                responseMKT = await SchoolLevelRepository.listTypeSchoolLevel()
              }
              responseMKT['data'].unshift({
                id: 1000,
                name: "Tất cả",
                schoolLevel: this.$store.state.listSchoolLevel || SCHOOL_LEVEL_LIST
              })
            } else {
              responseMKT = await ReportRepository.listTypeModuleViewMkt()
            }

            if(responseMKT){
                this.types = responseMKT.data
                this.filterForm.typeId = this.types[0]?.id || undefined
                this.tabs = this.getTabs(this.filterForm.typeId)
            }
        },
        onChangeTab() {
          this.filterForm.schoolLevelId = this.tabs[this.tab].id
          this.getContentReport()
        },
    }
}
</script>

<style lang="scss" scoped>
::v-deep .select-type-school {
    .v-select__selection ,.v-label , .v-icon{
        color: #fff !important;
    }
}
</style>